<h1 class="page-title mb-5"> المسئولية المجتمعية للشركات </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
                    <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
                        تنتمي الهيئة العامة للاستثمار والمناطق الحرة إلى وزارة الاستثمار وتنظيم الهيئات التنفيذية
                        الرئيسية في ​مصر. ​​
                    </p>
                </div>

                <ul class="links-nav-cont p-0 m-0" id="pills-tab" role="tablist">
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/SocialResponsibilityInvestment'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility.jpg"
                                    onerror="this.src='assets/images/placeholder.jpg'"
                                    title="  عن المسئولية المجتمعية للشركات في قانون الاستثمار "
                                    alt="عن المسئولية المجتمعية للشركات في قانون الاستثمار" />
                            </div>
                            <span>عن المسئولية المجتمعية للشركات في قانون الاستثمار</span>
                        </a>
                    </li>
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/CentralAdministrationResponsibility'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility1.jpg"
                                    onerror="this.src='assets/images/placeholder.jpg'" title="  عن الادارة المركزية للمسئولية المجتمعية
 " alt="عن الادارة المركزية للمسئولية المجتمعية
" />
                            </div>
                            <span>عن الادارة المركزية للمسئولية المجتمعية
                            </span>
                        </a>
                    </li>
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/TheExcellenceCompetitionComponent'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility2.png"
                                    onerror="this.src='assets/images/placeholder.jpg'" title="  مسابقة التميز في مجال التنمية المستدامة لعام 2023
 " alt="مسابقة التميز في مجال التنمية المستدامة لعام 2023
" />
                            </div>
                            <span>مسابقة التميز في مجال التنمية المستدامة لعام 2023
                            </span>
                        </a>
                    </li>
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/EqualOpportunities'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility3.jpg"
                                    onerror="this.src='assets/images/placeholder.jpg'" title="  تكافؤ الفرص
 " alt="تكافؤ الفرص
" />
                            </div>
                            <span>تكافؤ الفرص
                            </span>
                        </a>
                    </li>
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/EventsSocialResponsibilitiesComponent'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility4.png"
                                    onerror="this.src='assets/images/placeholder.jpg'" title=" الفاعليات
  " alt="الفاعليات
" />
                            </div>
                            <span>الفاعليات
                            </span>
                        </a>
                    </li>
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/latestReleases'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility5.jpg"
                                    onerror="this.src='assets/images/placeholder.jpg'" title=" أحدث الأصدارات
  " alt="أحدث الأصدارات
" />
                            </div>
                            <span>أحدث الأصدارات
                            </span>
                        </a>
                    </li>
                    <li class="links-nav">
                        <a class="link-nav-href" [routerLink]="'/HowwecanhelpcontactusComponent'" title="  ">
                            <div class="img-wrapper">
                                <img class="pill-img" src="../../../assets/responsibility6.jpg"
                                    onerror="this.src='assets/images/placeholder.jpg'" title="  انضم معنا
 " alt="انضم معنا
" />
                            </div>
                            <span>انضم معنا
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>